/**
 * @generated SignedSource<<475e2d23fa845e253e9d9f36ded912e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImagePublicOrPrivate_image$data = {
  readonly __typename: "Image";
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  readonly " $fragmentType": "ImagePublicOrPrivate_image";
} | {
  readonly __typename: "PublicImage";
  readonly " $fragmentSpreads": FragmentRefs<"ImagePublic_image">;
  readonly " $fragmentType": "ImagePublicOrPrivate_image";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ImagePublicOrPrivate_image";
};
export type ImagePublicOrPrivate_image$key = {
  readonly " $data"?: ImagePublicOrPrivate_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImagePublicOrPrivate_image">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ImagePublicOrPrivate_image",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImagePublic_image"
        },
        (v0/*: any*/)
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        },
        (v0/*: any*/)
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "type": "PublicAndInternalImage",
  "abstractKey": "__isPublicAndInternalImage"
};
})();

(node as any).hash = "7e4121067cd22c900ee45d0dfd2c7540";

export default node;
